$(document).on('click', '.accounts_filter', function() {
  $.ajax({
    type: "GET",
    url: '/accounts',
    data: {filter: $("input[name='filter']:checked").val() },
    dataType: "script"
  });
});